import React, { Fragment } from "react";
import HelpMessageItem from "./HelpMessageItem";

const HelpMessagesList = (props) => {
  const { dispatch, helpMessages, currentUrl, showNotification, deleteHelpMessage } = props;

  return (
    <>
      <div className="off-canvas-wrapper">
        <div
          className="inb-c-listing off-canvas-content"
          id="inb-c-main-orders"
          style={{ minHeight: "1150px" }}
        >
          {typeof helpMessages !== "undefined" &&
            helpMessages.length > 0 &&
            helpMessages.map((helpMessage, index) => {
              return (
                <Fragment key={typeof helpMessage.id !== "undefined" ? helpMessage.id : index}>
                  <HelpMessageItem
                    helpMessage={helpMessage}
                    index={index}
                    dispatch={dispatch}
                    currentUrl={currentUrl}
                    showNotification={showNotification}
                    deleteHelpMessage={deleteHelpMessage}
                  />
                </Fragment>
              );
            })}
        </div>
      </div>
    </>
  );
};
export default HelpMessagesList;
